function lerp(a, b, t) {
  return a + (b - a) * t;
}

function constrain(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function xx(...args) {
  return console.log(...args);
}

function random(min, max) {
  if (min === undefined) {
    min = 0;
    max = 1;
  }

  if (max === undefined) {
    max = min;
    min = 0;
  }

  return Math.random() * (max - min) + min;
}

function chance(c) {
  return random() < c;
}